import React from "react"
import { useFormFields, useMailChimpForm } from "use-mailchimp-form";


const NewsLetterArea = () => {
  const url = "https://gmail.us13.list-manage.com/subscribe/post?u=d314cbbbda77884b7896dd586&amp;id=729eb476af&amp;f_id=00c302e9f0";
  const {
      loading,
      error,
      success,
      message,
      handleSubmit
    } = useMailChimpForm(url);
  const { fields, handleFieldChange } = useFormFields({
    EMAIL: "",
  });


  return (
    <section className="newsletter-area section-py-80">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="newsletter__wrapper text-center">
              <img
                className="top-right"
                width="24"
                src="/assets/img/objects/x.png"
                alt="Object"
                style={{top:"16%",right:"16%"}}
              />

              <img
                className="top-left"
                width="16"
                src="/assets/img/objects/circle-01.png"
                alt="Object"
                style={{top:"16%",left:"8%"}}
              />

              <img
                className="bottom-right"
                width="44"
                src="/assets/img/objects/ethereum-02.png"
                alt="Object"
                style={{bottom:"16%",right:"8%"}}
              />
              <img
                className="bottom-left"
                width="32"
                src="/assets/img/objects/dcoin.png"
                alt="Object"
                style={{bottom:"24%",left:"16%"}}
              />

              <div
                className="section__title"
                data-anime="targets: > *; opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: anime.stagger(100);"
              >
                <h2 className="title">
                  Never <span className="tg-text-gradient">miss a drop!</span>
                </h2>
                <p>
                  Subscribe to our super-rare and exclusive drops &
                  collectibles.
                </p>




               
      <form
      className="newsletter__form"
        onSubmit={event => {
          event.preventDefault();
          handleSubmit(fields);
        }}
      >
        <input
          id="EMAIL"
          
          type="email"
          value={fields.EMAIL}
          onChange={handleFieldChange}
        />
        <button type="submit" className="btn gradient-btn">
                    Subscribe
                  </button>
      </form>
      {loading && "submitting"}
      {error && message}
      {success && message}
   




               
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsLetterArea
